import { WidgetViewMode } from 'utilitys/reporting/widgetViewModeUtils';

import { useUpdateIfReady } from 'components/Dashboards/Reporting/widgetInReport/hooks/RefreshWidgetPayload/useUpdateIfReady';
import { UseScheduleQualityScoreProvider } from 'components/widgets/ScheduleQualityScore/ScheduleQualityScore.provider';
import { getValueClassName } from 'components/widgets/ScheduleQualityScore/ScheduleQualityScore.utils';

interface Props {
    api: UseScheduleQualityScoreProvider['api'];
    setIsPayloadReady?: (newValue: boolean) => void;
    widgetViewMode: WidgetViewMode;
}

export const useScheduleQualityScoreLogic = ({ api, widgetViewMode, setIsPayloadReady }: Props) => {
    const isPayloadReady = () => {
        const currentPayload = api.getScheduleQualityScore.payload;
        if (!currentPayload) return;
        if (
            currentPayload.compareVersionId === undefined ||
            currentPayload.latestVersionId === undefined ||
            currentPayload.contractId === undefined ||
            currentPayload.contractId === null
        ) {
            return;
        }
        setIsPayloadReady && setIsPayloadReady(true);
    };

    const value = api.getScheduleQualityScore.instance.data?.value;
    const threshold = api.getScheduleQualityScore.instance.data?.threshold;
    useUpdateIfReady({ isPayloadReadyCallback: isPayloadReady, widgetViewMode: widgetViewMode });

    const calculatedValue = api.getScheduleQualityScore.instance.data?.value
        ? `${api.getScheduleQualityScore.instance.data?.value}%`
        : 'N/A';

    return {
        logic: {
            valueClassName: getValueClassName(value, threshold),
            calculatedValue,
        },
    };
};
